var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { ReactComponent as CancelCircleIcon } from "../../../assets/images/CancelCircleIcon.svg";
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { getUpdateKey } from "../../../builderPackage/common/commonFunctions";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { deleteAPI, setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch } from "../../../store/hooks";
import { CancelContractSaleOrderURL, ContractSaleOrderKeys } from "../services/entity";
export var ContractSaleOrderCancelPopup = function (_ref) {
    var onClose = _ref.onClose, id = _ref.id, type = _ref.type;
    var _a = useState(true), reason = _a[0], setReason = _a[1];
    var _b = useState(), cancellationReason = _b[0], setCancellationReason = _b[1];
    var dispatch = useAppDispatch();
    var formData = [{
            type: FormItemTypes.IconButton,
            name: '',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CancelCircleIcon, null),
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: '',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                fontSize: "small",
                color: "secondary"
            }),
            onClick: function () {
                onClose();
            },
            columnSize: 0
        }, {
            type: FormItemTypes.Typography,
            name: '',
            label: 'Are you sure you want to cancel order?',
            value: null,
            columnSize: 12,
            children: "Please enter a cancellation remark for cancelling this ".concat(type == 'invoiced' ? 'invoice' : 'order', "."),
            labelTypographyProps: {
                fontSize: "xl",
                fontWeight: "strong",
                color: "text.primary"
            }
        }, {
            type: FormItemTypes.TextInput,
            name: 'Remarks',
            label: 'Remark (0/200 characters)',
            placeholder: 'Enter a description...',
            maxLength: 200,
            value: null,
            minRows: 3,
            multiline: true,
            setFieldProps: function (formValues, value) {
                var _value$length;
                return {
                    type: this.type,
                    label: "Remark (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 characters)")
                };
            },
            onChange: function (e, value) {
                if (cancellationReason) {
                    if (value || (cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.Name) === 'Others') {
                        setReason(!(value !== null && value !== void 0 && value.trim()));
                    }
                    else {
                        setReason(value === null || value === void 0 ? void 0 : value.trim());
                    }
                }
            },
            columnSize: 12
        }, {
            type: FormItemTypes.Button,
            name: '',
            label: '',
            value: null,
            children: 'No',
            columnSize: 6,
            fullWidth: true,
            variant: 'outlined',
            color: 'secondary',
            onClick: function () {
                onClose();
            }
        }, {
            type: FormItemTypes.Button,
            name: '',
            label: '',
            value: null,
            children: 'Yes',
            columnSize: 6,
            fullWidth: true,
            color: 'error',
            variant: 'contained',
            onClick: function () { return 'submit'; }
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            padding: 2
        },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var _res$payload, request, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = _ref2.request;
                        return [4 /*yield*/, dispatch(deleteAPI({
                                key: '',
                                url: CancelContractSaleOrderURL(id),
                                request: {
                                    Remarks: request === null || request === void 0 ? void 0 : request.Remarks
                                }
                            }))];
                    case 1:
                        res = _a.sent();
                        if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && _res$payload.success) {
                            dispatch(setReducerState({
                                key: getUpdateKey(ContractSaleOrderKeys.Paging),
                                value: true
                            }));
                            dispatch(setReducerState({
                                key: getUpdateKey(ContractSaleOrderKeys.GetStatusCount),
                                value: true
                            }));
                            onClose();
                            return [2 /*return*/, {
                                    success: true
                                }];
                        }
                        else {
                            return [2 /*return*/, {
                                    success: false
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        updateRequest: {
            id: id
        },
        mode: "edit"
    });
};
